module.exports = __webpack_public_path__ + "static/media/macherel_misosoup.183cc0a1.jpg";